import React from 'react';
import Box from '@components/Atoms/Box';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

import { TestletSessionActivityActiveType } from '../types';

interface ActiveCellRendererProps {
  testletSession: any;
}

const ActiveCellRenderer: React.FC<ActiveCellRendererProps> = ({ testletSession }) => {
  const status = testletSession.active || '';

  const renderStatusIcon = () => {
    if (status === TestletSessionActivityActiveType.FOCUSED) {
      return <CheckIcon color="success" />;
    }
    if (status === TestletSessionActivityActiveType.UNFOCUSED) {
      return <CloseIcon color="error" />;
    }
    return <span>--</span>;
  };

  const hasStatus = !!status;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        '&:hover .info-icon': {
          opacity: hasStatus ? 1 : 0,
        },
      }}
    >
      {renderStatusIcon()}
    </Box>
  );
};

export default ActiveCellRenderer;
